// ---Dependencies
import React from 'react';
// ---Layout
import { Header } from '../clearances/components/Header';
import { Spinner } from '../clearances/components/Spinner';
import ClearanceMemoRouter from '../clearances/router';

/**
 * AuthorizedApp Component: Is the main app, providers and Hocs Can be added here
 * @returns {ReactElement}
 */
export const AuthorizedApp = () => (
    <>
        <Spinner />
        {/* Global Scope components can be added here */}
        <ClearanceMemoRouter />
    </>
);
